module.exports = __webpack_public_path__ + "img/Carbon2.5c4b81c0.jpg";